function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m 5.3400662,28.230133 c 0,-12.686798 10.2847698,-22.9715967 22.9715958,-22.9715967 12.686826,0 22.971596,10.2847987 22.971596,22.9715967 0,12.686798 -10.28477,22.971597 -22.971596,22.971597 -12.686826,0 -22.9715958,-10.284799 -22.9715958,-22.971597 z",
  fillRule: "evenodd",
  id: "path170",
  fill: "none",
  strokeWidth: 4.05681,
  stroke: "#e2f0d9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m 37.15835,38.479692 6.532276,7.002335",
  strokeWidth: 3.5708,
  id: "path1601",
  stroke: "#e2f0d9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m 35.535174,40.658689 -3.802181,-6.199477 2.092341,-1.665141 5.894088,4.534336 z",
  stroke: "#e2f0d9",
  strokeWidth: 2.80902,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "#e2f0d9",
  fillRule: "evenodd",
  id: "path2106"
});

function SvgTubevending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56.9 56.9",
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubevending);
export default __webpack_public_path__ + "static/media/tubevending.ab338162.svg";
export { ForwardRef as ReactComponent };